import { groupBy } from "lodash";

import APIClient from "web_modules/APIClient";

import { AppShape, ContactShape, DisclosureFee, DisclosureType } from "@eave/shared/types/api";

export const populateFeesFromClosingCorp = appId =>
  APIClient.post(`/uw/${appId}/populate_fees_from_closingcorp`, {});

export const agentHasGFEDataFees = agent => {
  const fees = agent.Fees;
  return fees && fees.some(fee => fee.source === "FeeSourceClosingCorpGFEDataResponse");
};

export const showPopulateClosingCorpFeesButton = (app: AppShape) => {
  // if already have ClosingCorp fees, don't allow pull

  const agents = app.contacts.suggested_settlement_agents;
  const hasClosingCorpFees = agents && agents.some(agent => agentHasGFEDataFees(agent));
  return !hasClosingCorpFees;
};

// per Ops, default to not an affiliate.
export const isSettlementCoAffiliate = (settlementCo: ContactShape) =>
  settlementCo !== null && settlementCo.is_affiliate === true;

export const feesByDisclosureSection = (fees: DisclosureFee[], disclosureType: DisclosureType) =>
  groupBy(fees, f =>
    disclosureType === DisclosureType.LoanEstimate ? f.le_section : f.cd_section,
  );
